import { render } from "./CallTransfers.vue?vue&type=template&id=8ba167b6"
import script from "./CallTransfers.vue?vue&type=script&lang=js"
export * from "./CallTransfers.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__